import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import FooterInfoPanel from './FooterInfoPanel';
import { getInfoPageKeyFromPath } from './infoPageContent';

const FooterInfoContext = createContext(null);

export function FooterInfoProvider({ children }) {
  const [infoPanelKey, setInfoPanelKey] = useState(null);

  const openInfoPanel = useCallback((pathOrKey) => {
    if (!pathOrKey) return;
    const key =
      typeof pathOrKey === 'string' && pathOrKey.startsWith('/')
        ? getInfoPageKeyFromPath(pathOrKey)
        : pathOrKey;
    if (key) setInfoPanelKey(key);
  }, []);

  const closeInfoPanel = useCallback(() => setInfoPanelKey(null), []);

  const value = useMemo(
    () => ({ infoPanelKey, openInfoPanel, closeInfoPanel }),
    [infoPanelKey, openInfoPanel, closeInfoPanel]
  );

  return (
    <FooterInfoContext.Provider value={value}>
      {children}
      <FooterInfoPanel pageKey={infoPanelKey} onClose={closeInfoPanel} />
    </FooterInfoContext.Provider>
  );
}

export function useFooterInfo() {
  const ctx = useContext(FooterInfoContext);
  if (!ctx) {
    throw new Error('useFooterInfo must be used within FooterInfoProvider');
  }
  return ctx;
}

export function useFooterInfoOptional() {
  return useContext(FooterInfoContext);
}
